import React, { Component } from "react";
import { Group, Layer, Line, Text, Rect } from "react-konva";
import { connect } from "react-redux";
import { getScaledValue } from "../../../actions/calculations-actions";
import { GLOBAL_PROJECT_TYPE_CHAMBER } from "../../../lib/types";
class Placeholder extends Component {

    render() {
        const {
            x,
            y,
            width,
            height,
            rotation,
            bedId,
            bedName,
            scaleX,
            scaleY,
            projectType,
        } = this.props;

        const isChamber = projectType === GLOBAL_PROJECT_TYPE_CHAMBER;

        return (
            <Layer>
                <Group key={bedId}
                    x={x}
                    y={y}
                    height={height}
                    width={width}
                    rotation={rotation}
                >
                    {this.renderLines()}
                    <Group key={bedId + bedName}
                        x={isChamber ? width * (scaleX || 1) : 0}
                        y={isChamber ? height * (scaleY || 1) : 0}
                        height={height * (scaleY || 1)}
                        width={width * (scaleX || 1)}
                        rotation={isChamber ? 180 : 0}
                    >
                        <Text text={bedName}
                            x={0}
                            y={0}
                            align={"center"}
                            verticalAlign={"middle"}
                            fontSize={Math.min(40, Math.round((height * (scaleY || 1)) / 4))}
                            height={height * (scaleY || 1)}
                            width={width * (scaleX || 1)}
                            wrap={"word"}

                        />
                    </Group>
                </Group>
            </Layer>
        );
    }

    renderLines() {
        const {
            points,
            selectedBed,
            getScaledValue,
            height,
            width,
            scaleX,
            scaleY
        } = this.props;

        const isSelectedBed = this.props.bedId === selectedBed.id;

        const dashStyle = isSelectedBed ? [10, 4] : [6, 6]
        const strokeWidth = getScaledValue(isSelectedBed ? 0.6 : 0.4);
        const strokeColor = isSelectedBed ? "#000" : "#ffb624";
        const fill = isSelectedBed ? "#00990044" : "#ffff5544";

        return points && points.length
            ? (
                <Line
                    key={"test"}
                    fill={fill}
                    dash={dashStyle}
                    points={points}
                    closed={true}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    lineJoin={"round"}
                />
            ) : (
                <Rect
                    key={"test"}
                    fill={fill}
                    dash={dashStyle}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    lineJoin={"round"}
                    x={0}
                    y={0}
                    height={height}
                    width={width}
                    scaleX={(scaleX || 1)}
                    scaleY={(scaleY || 1)}
                />
            );
    }
}

const mapStateToProps = state => {
    return {
        selectedBed: state.multiBed.selectedBed,
        projectType: state.globals.projectType,
    };
};

const mapDispatchToProps = {
    getScaledValue
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Placeholder);



// WEBPACK FOOTER //
// ./src/components/Drawings/MultiBed/placeholder.js